import { createAction } from "redux-actions";
import { apiPost, apiDelete, apiPatch } from "../../api/index";
import { urlNotificationSapSecured } from "../../api/urls";

export const createNotificationSap = createAction(
  "CREATE_NOTIFICATION_SAP",
  (productionOrderSapUuid, data) =>
    apiPost(urlNotificationSapSecured, data, productionOrderSapUuid, true)(),
);

export const deleteNotificationSap = createAction(
  "DELETE_NOTIFICATION_SAP",
  (notificationSapUuid) =>
    apiDelete(urlNotificationSapSecured, notificationSapUuid, true)(),
);

export const updateNotificationSap = createAction(
  "UPDATE_NOTIFICATION_SAP",
  (notificationSapUuid, data) =>
    apiPatch(urlNotificationSapSecured, data, notificationSapUuid, true)(),
);
